import React from 'react';
import { Box, TextField, Typography, MenuItem, Select } from '@mui/material';

function Gmail({ gmailData, setGmailData }) {
    return (
        <Box>

            {gmailData.errorStatus &&
                (<Typography sx={{ fontSize: '14px', fontWeight: '400', color: "#C30E2E" }}>
                    {gmailData.errorMessage}
                </Typography>)
            }

            <Box sx={{ width: '600px' }}>
                <Typography mb={1}>Subject Message <span style={{ color: 'red' }}>*</span></Typography>
                <TextField
                    variant="outlined"
                    type="text"
                    size='medium'
                    sx={{ width: '600px' }}
                    placeholder='Subject Message'
                    value={gmailData.subjectMessage}
                    onChange={(e) => setGmailData({ ...gmailData, subjectMessage: e.target.value })}
                />
            </Box>

            <Box mt={2}>
                <Typography marginBottom={'4px'}>Check for Import Every <span style={{ color: 'red' }}>*</span></Typography>
                <Select
                    size="small"
                    value={gmailData.importInterval}
                    sx={{ width: '150px' }}
                    onChange={(e) => setGmailData({ ...gmailData, importInterval: e.target.value })}
                >
                    <MenuItem value="one_minute">1 Minute</MenuItem>
                    <MenuItem value="five_minute">5 Minutes</MenuItem>
                    <MenuItem value="ten_minute">10 Minutes</MenuItem>
                    <MenuItem value="twenty_minute">20 Minutes</MenuItem>
                    <MenuItem value="thirty_minute">30 Minutes</MenuItem>
                </Select>
            </Box>

        </Box >
    )
}

export default Gmail;